// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/age/community.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'age.community',
	post: false,
	require: function(config, filter) { return sorted('age.community', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('g.game_age_community', sortReverse('age.community', filter), sortPriority('age.community', filter))
	}
}
